const getPlansIdByType = (ids, types) =>
  ids.reduce((acc, id) => acc.concat(types[id] || []), [])

export default getPlansIdByType
